import css from "styled-jsx/css";
import Colors from "/styles/colors";
import { BRAND_GREEN_DARK_TINT_01 } from "styles/color-consts";

export const componentStyles = css.global`
  .live-board-open-button {
    display: flex;
    align-items: baseline;
    flex-direction: row;
    width: 110px;
    background-color: #80e3ba;
    border-top-left-radius: 16px;
    border-bottom-left-radius: 16px;
    padding: 16px;
    cursor: pointer;
    .button-text {
      font-size: 12px;
      font-weight: 700;
      text-align: center;
      margin-right: 10px;
    }

    .pulse-circle {
      background: ${Colors[BRAND_GREEN_DARK_TINT_01]};
      width: 10px;
      height: 10px;
      border-radius: 50%;
      box-shadow: 0px 0px 1px 1px;
      animation: pulse-animation 2s infinite;
    }
  }

  @keyframes pulse-animation {
    0% {
      box-shadow: 0 0 0 0px rgba(0, 0, 0, 0.2);
    }
    100% {
      box-shadow: 0 0 0 20px rgba(0, 0, 0, 0);
    }
  }
`;
